import { Icons, Images } from "assets";
import classNames from "classnames";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ConfirmationModal from "shared/modal/confirmation";
import { resetAuthReducer } from "shared/redux/reducers/authSlice";
import { toastMessage } from "../toast";
import NavItem from "./navItem";
import styles from "./style.module.scss";
import { routeConstant } from "shared/routes/routeConstant";
import { Link } from "react-router-dom";

interface Props {
  sidebarArr: SideBarItemsType[];
}

function DashboardSidebar({ sidebarArr }: Props) {
  const { auth } = useSelector((state: any) => state.root);

  const dispatch = useDispatch();
  const [openConfirmationModal, setOpenConfirmationModal] =
    useState<boolean>(false);

  const handleOpenConfirmationModal = () => {
    setOpenConfirmationModal(true);
  };

  const handleCloseConfirmationModal = () => {
    setOpenConfirmationModal(false);
  };

  const handleLogout = () => {
    dispatch(resetAuthReducer());
    toastMessage("success", "Logged out successfully");
  };

  return (
    <div className={classNames(styles.sidebarWrapper)}>
      <div className="text-center w-full flex flex-col items-start">
        <div className={classNames(styles.logoTopContainerFull, "w-full px-2")}>
          <div
            className={classNames(
              "flex items-center w-full",
              styles.logoContainer
            )}
          >
            <Link to={routeConstant.dashboard.path}>
              <img
                className={classNames(styles.mainLogo)}
                width={150}
                height={50}
                src={Images.LogoIcon}
                alt="logo"
              />
              <img
                className={classNames(styles.logoIcon)}
                width={38}
                height={41}
                src={Images.LogoIcon}
                alt="logo"
              />
            </Link>
          </div>
        </div>
        <div
          className={classNames(
            "flex items-center gap-2",
            styles.userInfoContainer
          )}
        >
          <div className={classNames(styles.avtInitials)}>
            <label>
              {auth?.admin?.fullname?.split(" ")?.[0]?.[0]}
              {auth?.admin?.fullname?.split(" ")?.[1]?.[0]}
            </label>
          </div>
          <div className={classNames("flex flex-col items-start")}>
            <p>{auth?.admin?.fullname}</p>
            <span>{auth?.admin?.email}</span>
          </div>
        </div>
        <div
          className={classNames(
            "flex flex-col justify-between h-full mt-3 gap-3"
          )}
          style={{ backgroundColor: "#231F20" }}
        >
          <div
            className={classNames(styles.sideNavFull, "flex flex-col gap-1")}
          >
            {sidebarArr?.map((item, inx) => {
              return (
                <div className="flex flex-col items-start gap-1" key={inx}>
                  <label className={classNames(styles.navTitle)}>
                    {item?.title}
                  </label>

                  <div className="w-full flex flex-col gap-0">
                    {item?.paths?.map(
                      (s: SideBarItemPathType, s_inx: number) => {
                        const props = {
                          ...s,
                        };
                        return <NavItem {...props} key={s_inx} />;
                      }
                    )}
                  </div>
                </div>
              );
            })}
          </div>
          <div
            className={classNames(styles.navItemContainer, "pb-4")}
            onClick={handleOpenConfirmationModal}
          >
            <Icons.Logout className={classNames(styles.logoutIcon)} />
            <label
              className={classNames(
                styles.heading,
                styles.logout,
                "cursor-pointer"
              )}
            >
              Logout
            </label>
          </div>
        </div>
      </div>
      <ConfirmationModal
        // @ts-ignore
        show={openConfirmationModal}
        handleClose={handleCloseConfirmationModal}
        subtitle="Are you sure you want to logout?"
        actionButtonText="Yes, Logout"
        handleSubmit={handleLogout}
      />
    </div>
  );
}

export default DashboardSidebar;
